import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import LoginPage from "../operations/pages/LoginPage/LoginPage";

export const PublicRoutes = () => {

  const authToken = localStorage.getItem("authToken");

  const isTokenExpired = () => {
    if (!authToken) return true;

    try {
      const payload = JSON.parse(atob(authToken.split(".")[1]));
      return Date.now() > payload.exp * 1000;
    } catch {
      return true;
    }
  };

  const tokenExpired = isTokenExpired();

  if (tokenExpired) {
    localStorage.removeItem("authToken");
  }

  return (
    <Routes>
      <Route
        path="/"
        element={
          authToken && !tokenExpired ? (
            <Navigate to="/landing" replace />
          ) : (
            <LoginPage />
          )
        }
      />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};